import { useLocation, useSearchParams } from "react-router-dom";

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}
export function getQueryParameterName(paramName: string) {
  const query = useQuery();
  return query.get(paramName);
}

export function useDynamicQueryParameter(paramName: string) {
  const [searchParams] = useSearchParams();
  return searchParams.get(paramName);
}

export function changesQueryParameter(cb: Function, queryList: any) {
  let queryObj = {};
  queryList.forEach((query: any) => {
    queryObj = { ...queryObj, ...query };
  });
  return cb(queryObj);
}
